export default __webpack_public_path__ + "static/media/check-marks.b697b8fe.png";